<!--
 * @Author: ningbo.kang
 * @Date: 2021-06-02 09:59:01
 * @LastEditors: JikeyChang
 * @LastEditTime: 2022-04-07 11:07:51
 * @Description: 描述
-->
<template>
  <svg aria-hidden="true"
    class="svg-icon"
    :class="fontSize">
    <use :xlink:href="icon"></use>
  </svg>
</template>

<script>
export default {
  name: 'e2-svg',
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: false,
      default: 'default',
      validator(value) {
        // 这个值必须匹配下列字符串中的一个
        return ['default', 'middle', 'small', 'large'].indexOf(value) !== -1;
      },
    },
  },
  computed: {
    icon() {
      return `#e2-icon_${this.name}`;
    },
    fontSize() {
      return `svg-icon-${this.size}`;
    },
  },
};
</script>
